import { useTranslation, Trans } from "react-i18next"
import { useEffect, useRef, useState } from "react"
import styles from "./DataBanner.module.scss"

const AnimatedNumber = ({ value, duration = 2000, locale = "es-ES", decimals = 0 }) => {
  const [displayValue, setDisplayValue] = useState(0)

  useEffect(() => {
    const startTime = performance.now()

    const step = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1)
      const currentValue = progress * value
      setDisplayValue(currentValue)
      if (progress < 1) requestAnimationFrame(step)
    }

    requestAnimationFrame(step)
  }, [value, duration])

  return (
    <>
      {new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(displayValue)}
    </>
  )
}

const DataBanner = () => {
  const { i18n } = useTranslation();

  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const wrapperRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true)
        }
      },
      { threshold: 0.5 } // activa cuando el 50% del componente está visible
    )
    if (wrapperRef.current) observer.observe(wrapperRef.current)
    return () => observer.disconnect()
  }, [])

  const number1 = 15
  const number2 = 40000
  const number3 = 100
  const number4 = 7.4
  const number5 = 420

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <h2 className={styles.title}>
        {t("Juntos, contribuimos a un futuro más sostenible.")}
      </h2>
      <div className={styles.dataBanneContainer}>
        <div>
          <p>
            <span className={styles.bigText}>
              <Trans i18nKey="15_anos">
                {visible && <AnimatedNumber value={number1} locale={i18n.language} />}
              </Trans>
            </span>
            {t("de_experiencia")}
          </p>
        </div>
        <div>
          <p>
            <span className={styles.bigText}>
              <Trans i18nKey="40000">
                {visible && <AnimatedNumber value={number2} locale={i18n.language} />}
              </Trans>
            </span>
            {t("cargadores_instalados")}
          </p>
        </div>
        <div>
          <p>
            <span className={styles.bigText}>
              <Trans i18nKey="100">
                {visible && <AnimatedNumber value={number3} locale={i18n.language} />}
              </Trans>
            </span>
            {t("de_cargas")}
          </p>
        </div>
        <div>
          <p>
            <span className={styles.bigText}>
              <Trans i18nKey="7.4_420">
                {visible && <AnimatedNumber value={number4} locale={i18n.language} decimals={1} />}
                {visible && <AnimatedNumber value={number5} locale={i18n.language} />}
              </Trans>
            </span>
            {t("de_potencia")}
          </p>
        </div>
      </div>
    </div>
  )
}

export default DataBanner